import React, { useState } from 'react';
import { ArtistDTO } from '../../spotipitan/types';
import { Spotip17anFunctions } from '../../../../utils/api';
import useUserStore from '../../../../store/UserState';
import { useNavigate } from 'react-router-dom';
import { LoginHome } from '../../../users';
import toast from "react-hot-toast";
import PaginatedPlaylistList from "../../../shared/paginated-playlist-list";

type Props = {
    headerOptions?: React.ReactNode;
    searchQuery?: string;
}

const SavedPlaylists = ({ headerOptions, searchQuery }: Props) => {
    const [playlists, setPlaylists] = useState<ArtistDTO[]>([]);
    const { user } = useUserStore(state => state.state);
    const navigate = useNavigate();

    if (!user?.uid) {
        return (
            <div className="fade custom-modal modal show" style={{
                position: 'initial',
                opacity: 1,
                paddingBottom: '60px',
                display: 'block',
                height: 'fit-content',
            }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <LoginHome onClose={() => navigate("/")} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="d-flex align-items-center mb-4 my-playlists-header">
                <h2 className="mb-0">Playlists Guardadas</h2>
                {headerOptions}
            </div>
            <PaginatedPlaylistList
                searchQuery={searchQuery}
                functionName={"myPlaylistSubscriptions"}
                onPlaylistClick={(playlist) => navigate(`/playlist/${playlist.id}`)}
                extraOptions={[
                    {
                        text: "Eliminar de guardados",
                        icon: <i className="fa-regular fa-circle-xmark"></i>,
                        onClick: async (playlist) => {
                            try {
                                await Spotip17anFunctions.use('unsubscribePlaylist').call({ playlistId: playlist.id + "" });
                                setPlaylists(playlists.filter(p => p.id !== playlist.id));
                                toast.success('Playlist eliminada de guardados');
                            } catch (error) {
                                toast.error('Error al eliminar la playlist');
                                console.error(error);
                            }
                        }
                    }
                ]}
            />
        </div>
    );
};

export default SavedPlaylists; 
